import { number, bool, string, func } from 'prop-types';
import { formatPriceRange, formatPriceNoCurrencySymbol } from '@dmi-mch/utils';
/*
If has sold, returns soldLabel. Doesn't care another parameters of prices.
If has priceInUsd, returns formated single price. Doesn't care another parameters of price range.
If has fromPrice or toPrice, returns formated price range.
If hasn't sold or any price, returns null.
*/

var PriceLabel = function PriceLabel(_ref) {
  var children = _ref.children,
      priceInUsd = _ref.priceInUsd,
      priceInSecondCurrency = _ref.priceInSecondCurrency,
      secondCurrency = _ref.secondCurrency,
      fromPrice = _ref.fromPrice,
      toPrice = _ref.toPrice,
      sold = _ref.sold,
      _ref$soldLabel = _ref.soldLabel,
      soldLabel = _ref$soldLabel === void 0 ? 'Sold' : _ref$soldLabel;

  if (!sold && priceInSecondCurrency) {
    var _result = null;
    _result = "".concat(secondCurrency, " ").concat(formatPriceNoCurrencySymbol(priceInSecondCurrency));
    return _result && children(_result);
  }

  var hasPriceInUsd = Number(priceInUsd) > 0;
  var hasPriceRange = Number(fromPrice) > 0 || Number(toPrice) > 0;
  var result = null;

  if (sold) {
    result = soldLabel;
  } else if (hasPriceInUsd) {
    // not using dollar symbol anymore but currency code
    result = "USD ".concat(formatPriceNoCurrencySymbol(priceInUsd));
  } else if (hasPriceRange) {
    result = formatPriceRange(fromPrice, toPrice);
  }

  return result && children(result);
};

PriceLabel.propTypes = {
  children: func.isRequired,
  priceInUsd: number,
  fromPrice: number,
  toPrice: number,
  sold: bool,
  soldLabel: string,
  priceInSecondCurrency: number,
  secondCurrency: string
};
export default PriceLabel;